<script>
  import { localizeImportedAt } from "./tableUtils.js";
  import Message from "../../parts/Message.svelte";
  import TextSkeleton from "../../../../../components/skeletons/TextSkeleton.svelte";

  export let isImportsLoaded = false
  export let isLatestSelected = true
  export let importedAt = null
</script>

{#if isImportsLoaded}
  <span>
    {#if isLatestSelected}
      現在の設定: インポートされている中で最新のデータを使用する
    {:else}
      現在の設定: 過去のデータを使用する
    {/if}
    {#if importedAt}
      (インポート日時: {localizeImportedAt(importedAt, "ja")})
    {:else}
      <Message type="error">
        (インポートされたデータがまだありません。データをインポートしてください。)
      </Message>
    {/if}
  </span>
{:else}
  <TextSkeleton />
{/if}
